import React from 'react';
import { TOfferContextData } from '../types/offer-card';

export const OfferContext = React.createContext<TOfferContextData | null>(null);

export function useOfferContext() {
  return React.useContext(OfferContext) as TOfferContextData;
}
